import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IProperty } from "../propertyModel";

export const getAllProperties = createAsyncThunk(
  "Property/FindAllProperty",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Property/FindAllProperty`,
        {},
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Properties:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createProperty = createAsyncThunk(
  "Property/InsertProperty",
  async (PropertyData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Property/InsertProperty`,
        PropertyData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Property:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateProperty = createAsyncThunk(
  "Property/UpdateProperty",
  async (PropertyData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Property/UpdateProperty`,
        PropertyData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Property:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteProperty = createAsyncThunk(
  "Property/DeleteProperty",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Property/DeleteProperty`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Property :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPropertyByID = createAsyncThunk(
  "Property/FindByIDsProperty",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Property/FindByIDsProperty`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        PropertyName: result?.PropertyName,
        PropertyURL: result?.PropertyURL,
        BookingURL: result?.BookingURL,
        TagLine: result?.TagLine,
        Address: result?.Address,
        MapURL: result?.MapURL,
        MobileNo: result?.MobileNo,
        EmailID: result?.EmailID,
        ShortDescription: result?.ShortDescription || "",
        LongDescription: result?.LongDescription || "",
        DiningInfo: result?.DiningInfo || "",
        Tags: result?.Tags,
        SequenceNo: result?.SequenceNo,
        TotalRoom: result?.TotalRoom,
        IsHightlightProperty: result?.IsHightlightProperty || false,
        MetaTitle: result?.MetaTitle,
        MetaDescription: result?.MetaDescription,
        MetaKeywords: result?.MetaKeywords,
        BannerImages: result?.BannerImages,
        InnerImages: result?.InnerImages || [],
        GalleryImages: result?.GalleryImages || [],
        IsActive: result.IsActive ? 1 : 2,
      } as IProperty;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Property :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveProperties = createAsyncThunk(
  "Property/FindAllActiveProperty",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Property/FindAllActiveProperty`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Properties:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveProperty = createAsyncThunk(
  "Property/ActiveInActiveProperty",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Property/ActiveInActiveProperty`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Property :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD
export const PropertyDetailsImageUpload = createAsyncThunk(
  "Property/PropertyImagesUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Property/PropertyImagesUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Property Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePropertyImage = createAsyncThunk(
  "Property/DeletePropertyImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Property/DeletePropertyImage`,
        { ID: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting property image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteGalleryImage = createAsyncThunk(
  "Property/DeletePropertyGalleryImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Property/DeletePropertyGalleryImage`,
        { ID: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting property image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
